import { ApolloClient, ApolloLink } from '@apollo/client'
import { createUploadLink } from 'apollo-upload-client'
import omitDeep from 'omit-deep'

function errorsCleanUpLink() {
  return new ApolloLink((operation, forward) => {
    return forward(operation).map((response) => {
      if (
        Array.isArray(response?.errors) &&
        response?.errors?.some((error) => error?.extensions?.code === 401)
      ) {
        response?.errors?.forEach((error) => {
          if (error.extensions?.code === 401) {
            response.errors = null
          }
        })
      }
      return response
    })
  })
}

function skipIntrospectionQueryLink() {
  return new ApolloLink((operation, forward) => {
    if (operation.operationName === 'IntrospectionQuery') {
      return null
    }
    return forward(operation)
  })
}

const variablesCleanupLink = new ApolloLink((operation, forward) => {
  if (operation.variables) {
    // Don't clean variables if it's a file upload
    const hasFileUpload = Object.values(operation.variables).some(
      value => value instanceof File || value instanceof Blob
    )
    
    if (!hasFileUpload) {
      operation.variables = omitDeep(JSON.parse(JSON.stringify(operation.variables)), '__typename')
    }
  }
  return forward(operation)
})

export function createClient(uri, apiKey, cache) {
  const httpLink = createUploadLink({
    uri,
    headers: {
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      'X-Api-Key': apiKey,
    },
    credentials: 'include',
  })
  
  const client = new ApolloClient({
    link: ApolloLink.from([
      skipIntrospectionQueryLink(),
      errorsCleanUpLink(),
      variablesCleanupLink,
      httpLink, // Upload link skal være sidst
    ]),
    cache,
  })

  return client
}
